// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IParkingItemSchema {
  /** Значение **/
  title: string;
  /** Тип парковки **/
  type: EType;
}

export enum EType {
  /** Гостевая **/
  'Guest' = 'guest',
  /** Отдельная многоуровневая **/
  'Standalone' = 'standalone',
  /** Подземная **/
  'Underground' = 'underground',
}
